import { useContext } from '@wordpress/element';
import { NavigatorContext } from './context';
/**
 * Retrieves a `navigator` instance. This hook provides advanced functionality,
 * such as imperatively navigating to a new location (with options like
 * navigating back or skipping focus restoration) and accessing the current
 * location and path parameters.
 */
export function useNavigator() {
  const {
    location,
    params,
    goTo,
    goBack,
    goToParent
  } = useContext(NavigatorContext);
  return {
    location,
    goTo,
    goBack,
    goToParent,
    params
  };
}